import moment from "moment-jalaali";
export default {
  data() {
    return {
      busy: false,
      allPies: [],
    };
  },
  methods: {
    getAllPies() {
      this.busy = true;
      this.$http
        .get(this.baseUrl + "/pies/listForUser", {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        })
        .then((res) => {
          this.busy = false;
          if (res.status == 200) {
            this.allPies = res.data;
            this.busy = false;
          } else {
            this.toast("خطا: مشکلی پیش آمده. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          this.busy = false;
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    tsConverter(date) {
      return moment(date, "jYYYY/jMM/jDD - HH:mm").format("X");
    },
  },
};
